import BaseText from "../../../components/general/BaseText";
import { BaseCardContainer, BaseCardContent, BaseCardHeader, BaseCardTitle, BaseGeneralCard } from "../../../components/general/BaseCard";
import BaseLabel from "../../../components/general/BaseLabel";
import BaseIcon from "../../../components/general/BaseIcon";

export type SoftwareCardProps = {
    title: string;
    subtitle: string;
    description: string;
    color?: "blue" | "orange";
    align?: "left" | "right";
    icon?: string
    onClick?: () => void
};

export function SoftwareCard({
    title,
    subtitle,
    description,
    color = "blue",
    align = "left",
    icon,
    onClick,
}: SoftwareCardProps) {
    const toneClass = color === "blue" ? "text-primary" : "text-secondary";
    const iconToneClass = color === "blue" ? "bg-primary/10" : "bg-secondary/10";
    const iconStroke = color === "blue" ? "text-primary" : "text-secondary";
    const borderHoverClass = color === "blue" ? "hover:border-primary/70" : "hover:border-secondary/70";

    return (
        <div className={`w-full flex ${align === "right" ? "justify-end" : "justify-start"}`}>
            <BaseCardContainer
                onClick={onClick}
                className={`max-w-md w-full gap-0 rounded-2xl border-base-300/60 bg-neutral transition-colors duration-300 cursor-pointer ${borderHoverClass}`}

            >
                <BaseCardHeader className="flex flex-col items-start gap-2 ">
                    <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-2 ${iconToneClass} ${iconStroke}`}>
                        
                        <BaseIcon name={icon ?? "software"}/>
                    </div>
                    <BaseCardTitle
                        title={title}
                        tag="h5"
                        className="!pb-2"
                    />
                </BaseCardHeader>
                <BaseCardContent className="">


                    <BaseText
                        text={subtitle}
                        classProps={`!py-0 text-sm ${toneClass}`}
                        textColor={toneClass}
                    />
                    <BaseText
                        text={description}
                        classProps="!py-0 mt-1 text-base leading-relaxed"
                        textColor="text-accent"
                    />
                </BaseCardContent>
            </BaseCardContainer>
        </div>
    );
}
